import moment from "moment";
import React from "react";
import { forwardRef } from "react";
const MFFundHoldingReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      handleScrollScript,
      // hasVerticalScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column" style={{ width: "570%" }}>
        <thead>
          <tr>
            <th scope="col" className={clientDashboard ? "text-center" : ""}>
              Sr No.
            </th>
            <th scope="col" className="text-center">
                User ID
            </th>
            <th scope="col" className="text-center">
              PAN
            </th>
            <th scope="col" className="text-center">Folio ID
            </th>
            <th scope="col" className="text-center">
              Scheme Investment Type
            </th>
            <th scope="col" className="text-center">Investment Type
            </th>
            <th scope="col" className="text-center">Scheme Name
            </th>
            <th scope="col" className="text-center">ISIN
            </th>
            <th scope="col" className="text-center">Current Value
            </th>
            <th scope="col" className="text-center">Invested Value
            </th>
            <th scope="col" className="text-center">Returns
            </th>
            <th scope="col" className="text-center">Absolute Returns
            </th>
            <th scope="col" className="text-center">CAGR
            </th>
            <th scope="col" className="text-center">NAV
            </th>
            <th scope="col" className="text-center">Units
            </th>
            <th scope="col" className="text-center">Dividend
            </th>
            <th scope="col" className="text-center">One Day Change
            </th>
            <th scope="col" className="text-center">One Day Change Per
            </th>
            <th scope="col" className="text-center">Folio Number
            </th>
            <th scope="col" className="text-center">BSE Order Number
            </th>
            <th scope="col" className="text-center">
              Amount
            </th>
            <th scope="col" className="text-center">Next Instalment Date
            </th>
            <th scope="col" className="text-center">Avg. NAV
            </th>
            <th scope="col" className="text-center">Current NAV Date
            </th>
            <th scope="col" className="text-center">Distributor
            </th>
            <th scope="col" className="text-center">Scheme Code
            </th>
            <th scope="col" className="text-center">SIP Status
            </th>
            <th scope="col" className="text-center">Investment Amount
            </th>
            <th scope="col" className="text-center">Flag
            </th>
            <th scope="col" className="text-center">Mandate Token ID
            </th>
            <th scope="col" className="text-center">SIP Dates
            </th>
            <th scope="col" className="text-center">AMC Code
            </th>
            <th scope="col" className="text-center">Category
            </th>
            <th scope="col" className="text-center">Main Category
            </th>
            <th scope="col" className="text-center">Min SIP Amt.
            </th>
            <th scope="col" className="text-center">Max SIP Amt.
            </th>
            <th scope="col" className="text-center">Min Purchase Amt.
            </th>
            <th scope="col" className="text-center">Max Purchase Amt.
            </th>
            <th scope="col" className="text-center">Purchase Date
            </th>
            <th scope="col" className="text-center">XIRR
            </th>
            <th scope="col" className="text-center">Unrealised PNL
            </th>
            {/* {hasVerticalScroll && <th className="scrollerthead"></th>} */}
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td className={clientDashboard ? "text-center" : ""}>
                    {index + 1}
                  </td>
                  <td>{item?.userId}</td>
                  <td>{item?.pan || "-"}</td>
                  <td>{item?.folioId || "-"}</td>
                  <td>{item?.schInvType || "-"}</td>
                  <td>{item?.invType || "-"}</td>
                  <td>{item?.schName || "-"}</td>
                  <td>{item?.isin || "-"}</td>
                  <td>{item?.currVal || "-"}</td>
                  <td>{item?.invAmt || "-"}</td>
                  <td>{item?.returns || "-"}</td>
                  <td>{item?.absRet || "-"}</td>
                  <td>{item?.cagr || "-"}</td>
                  <td>{item?.nav || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.dividend || "-"}</td>
                  <td>{item?.oneDayChg || "-"}</td>
                  <td>{item?.oneDayChgPer || "-"}</td>
                  <td>{item?.folioNo || "-"}</td>
                  <td>{item?.bseOrderNo || "-"}</td>
                  <td>{item?.amt || "-"}</td>
                  <td>
                    {item?.nxtInstDt
                      ? moment(item?.nxtInstDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.avgNav || "-"}</td>
                  <td>
                    {item?.currNavDt
                      ? moment(item?.currNavDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.distributor || "-"}</td>
                  <td>{item?.bseSchCode || "-"}</td>
                  <td>{item?.sipStatus || "-"}</td>
                  <td>{item?.instAmt || "-"}</td>
                  <td>{item?.sipFlag || "-"}</td>
                  <td>{item?.mandateId || "-"}</td>
                  <td>{item?.sipDates || "-"}</td>
                  <td>{item?.amcCode || "-"}</td>
                  <td>{item?.category || "-"}</td>
                  <td>{item?.mainCategory || "-"}</td>
                  <td>{item?.minSIPAmt || "-"}</td>
                  <td>{item?.maxSIPAmt || "-"}</td>
                  <td>{item?.minPurchAmt || "-"}</td>
                  <td>{item?.maxPurchAmt || "-"}</td>
                  <td>
                    {item?.purchDt
                      ? moment(item?.purchDt).format("DD-MM-YYYY")
                      : "-"}
                  </td>
                  <td>{item?.xirr || "-"}</td>
                  <td>{item?.unrealisedPNL || "-"}</td>
                </tr>
              );
            })}
          
        </tbody>
        {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
      </table>
      </div>
    );
  }
);

export default MFFundHoldingReportTable;
